import CompanyRoutes from '../../../apiRoutes/CompanyRoutes';
import { api } from '../../ConsumeApiController';


export async function searchPosProducts(merchantUuid, query = '', categoryId = null) {
    try {
        const url = CompanyRoutes.POS.PRODUCTS_SEARCH;
        const response = await api.post(url, { 
            merchant_uuid: merchantUuid,
            query: query,
            category_id: categoryId
        });

        // Retornamos el array de productos filtrados o vacío
        return response.success ? response.data : [];
    } catch (error) {
        console.error("Error filtering products:", error);
        return [];
    }
}

export async function initPos(merchantUuid) {
    try {
        const url = CompanyRoutes.POS.INIT;
        const response = await api.post(url, { merchant_uuid: merchantUuid });

        if (response.success) {
            const { categories, top_products } = response.data;
            return { categories, top_products };
        }

        return { categories: [], top_products: [] };

    } catch (error) {
        console.error("Error al inicializar el catálogo POS:", error);
        return { categories: [], top_products: [] };
    }
}